import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { ESTRUCTURASBALANCE_LISTA } from 'constants/codigosTransacciones'

import * as EstructuraBalancePages from './estructura-balance'


export default function ContabilidadCostosPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${ESTRUCTURASBALANCE_LISTA}`} component={EstructuraBalancePages.ListaPage} />
      </Switch>
    </Suspense>
  )
}
